

import RequestAbstract from "../abstract";

export default class WalletUsers extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet/users";
    }
}

